import type { Palette } from './palette';
import type { Block } from './types';

export type SeriesOverride = { label?: string; color?: number | string; hidden?: boolean };

export const seriesOverrides = (block: Block | undefined): Record<string, SeriesOverride> => (block?.series ?? {}) as Record<string, SeriesOverride>;

export function overrideColor(override: SeriesOverride | undefined, palette: Palette, fallback: string): string {
  const color = override?.color;
  if (typeof color === 'number' && color >= 1) return palette.series[(color - 1) % palette.series.length];
  if (color === 'muted') return palette.muted;
  if (typeof color === 'string' && /^#[0-9a-f]{6}$/i.test(color)) return color;
  return fallback;
}
